import {
  Project,
  ProjectVirtualGraph,
  ProjectsState,
} from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';
import { dataSourceTableToSelectItem } from 'src/utils/select/dataSourceTableToSelectItem';

// prevState must be typed as `any` since it's an older version of the Redux State
export const v1 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v1Projects(nextState.projects);
  }

  return nextState;
};

const v1Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    const virtualGraphsById: Record<string, ProjectVirtualGraph> = {};

    Object.entries(project.virtualGraphsById).forEach(
      ([virtualGraphId, virtualGraph]) => {
        virtualGraphsById[virtualGraphId] = {
          ...virtualGraph,
          from:
            typeof virtualGraph.from === 'string'
              ? virtualGraph.from
              : dataSourceTableToSelectItem({
                  name: virtualGraph.from.value,
                  schema: '',
                }),
        };
      }
    );

    projectsById[projectId] = {
      ...project,
      virtualGraphsById,
    };
  });

  return { ...prevProjectsState, projectsById };
};
